






































































import { Component, Prop, Vue, Watch } from 'vue-property-decorator';

import CommonLayerDrawer from './layerDrawer/commonLayerDrawer/commonLayerDrawer.vue';
import BoundingBox from './boundingBox/boundingBox.vue';
import LineController from './lineController/lineController.vue';
import CurveController from './curveController/curveController.vue';
import PolygonController from './polygonController/polygonController.vue';
import TrimBox from './trimBox/trimBox.vue';
import TextEditor from './textEditor/textEditor.vue';
import InlineTextEditor from './inlineTextEditor/inlineTextEditor.vue';
import SizeController from './_mobile/sizeController.vue';

// TODO document2
import { Design } from '@/model/document2/page/surface/design/design'

import * as def from '@/definitions'
import { Const } from '@/const'
import { Layer } from '@/model/document2/page/surface/design/layer/layer';
import { TextLayer } from '@/model/document2/page/surface/design/layer/textLayer';
import { PolygonLayer } from '@/model/document2/page/surface/design/layer/polygonLayer';
import { PlainTextLayer } from '@/model/document2/page/surface/design/layer/plainTextLayer';
import { ImageLayer } from '@/model/document2/page/surface/design/layer/imageLayer';
import { Vector2 } from '@/utilityModels/vector2'
import { Rectangle } from '@/utilityModels/rectangle'
import { FontManager } from '@/model/fontManager/fontManager';
import { LineLayer } from '@/model/document2/page/surface/design/layer/lineLayer';
import { CurveLayer } from '@/model/document2/page/surface/design/layer/curveLayer';
import { TableLayer } from '@/model/document2/page/surface/design/layer/tableLayer';
import { ImageHelper } from '@/helper/imageHelper';
import { HtmlHelper } from '@/helper/htmlHelper';
import { Page } from '@/model/document2/page/page';
import { UnitHelper } from '@/helper/unitHelper';
import { MathHelper } from '@/helper/mathHelper';
import { StringHelper } from '@/helper/stringHelper';
import { UserAgentHelper } from '@/helper/userAgentHelper';
import { DebugHelper } from "@/helper/debugHelper";
import { NativeHelper } from "@/helper/nativeHelper";

const isElement = (x: any): x is Element =>
  x instanceof Element;

@Component({
  components: {
    CommonLayerDrawer,
    BoundingBox,
    LineController,
    CurveController,
    PolygonController,
    TrimBox,
    TextEditor,
    InlineTextEditor,
    SizeController
  },
})

//******************************************//
//**************** モバイル用 ****************//
//******************************************//
export default class CanvasWindow extends Vue 
{
    @Prop() private documentRotate! : number;
    @Prop() private design! : Design;
    @Prop() private page! : Page;
    @Prop() private isReverseSurface! : boolean;
    @Prop({default: 100}) private zoomScale! : number;
    @Watch('zoomScale')
    onZoomScaleChanged(val: number, oldVal: number)
    {
        this.adjustFrameSize();
        this.$nextTick(() => {
            this.adjustFramePosition()
            if(!this.isAutoZoom){
                this.zoomPositioning(val, oldVal);
                // this.pointUpdate();
            }else{
                this.autoZoomPositioning();
            }
        });

        this.updateScaleFromPixels();
    }
    @Prop({default: false}) private isAutoZoom! : boolean;
    @Watch('isAutoZoom')
    onIsAutoZoomChanged(val: boolean, oldVal: boolean)
    {
        if(val){
            this.autoResize();
            this.$nextTick(() => this.autoZoomPositioning());
        }else{
            var canvasWindow = this.$refs.canvasWindow as Element;
            this.scrollPosition = {left: canvasWindow.scrollLeft, top: canvasWindow.scrollTop};
        }
    }
    @Prop() private isRendering! : boolean;

    @Prop() private isSubControllerVisible! : boolean;
    
    @Prop() private paperInfoText! : string;
    @Prop() private isFontLoaded! : boolean;
    @Prop() private popupTouchState! : string;

    // CommonLayerDrawerに渡すためのgetter
    private get useSimpleText() { return this.$store.getters.applicationState.useSimpleText; }
    private get moveLayerMode() { return this.$store.getters.applicationState.moveLayerMode; }
    private get moveLayerId() { return this.$store.getters.applicationState.moveLayerId; }

    // canvas-window表示領域の基準サイズ。このサイズに収まるサイズが100%
    static readonly CANVAS_WINDOW_BASE_WIDTH = 1160;
    static readonly CANVAS_WINDOW_BASE_HEIGHT = 854;
    // 固定pxとなるウィンドウサイズ
    static readonly FIXED_PX_BASE_WIDTH = 900;
    static readonly FIXED_PX_BASE_HEIGHT = 640;

    // キャンバスのオフセットはキャンバスサイズの何倍にするか
    static readonly CANVAS_OFFSET_FACTOR = 4;

    // マウス移動時の動作
    static MOUSE_MOVING_MODE_NONE = "none";
    static MOUSE_MOVING_MODE_ROTATE = "rotate";
    static MOUSE_MOVING_MODE_MOVE = "move";
    static MOUSE_MOVING_MODE_MOVE_MULTI = "move_multi";
    static MOUSE_MOVING_MODE_RESIZE_FROM_TOP_LEFT = "resize_from_top_left";
    static MOUSE_MOVING_MODE_RESIZE_FROM_LEFT = "resize_from_left";
    static MOUSE_MOVING_MODE_RESIZE_FROM_BOTTOM_LEFT = "resize_from_bottom_left";
    static MOUSE_MOVING_MODE_RESIZE_FROM_BOTTOM = "resize_from_bottom";
    static MOUSE_MOVING_MODE_RESIZE_FROM_BOTTOM_RIGHT = "resize_from_bottom_right";
    static MOUSE_MOVING_MODE_RESIZE_FROM_RIGHT = "resize_from_right";
    static MOUSE_MOVING_MODE_RESIZE_FROM_TOP_RIGHT = "resize_from_top_right";
    static MOUSE_MOVING_MODE_RESIZE_FROM_TOP = "resize_from_top";
    static MOUSE_MOVING_MODE_CONTROL_LINE_START = "control_line_start";
    static MOUSE_MOVING_MODE_CONTROL_LINE_END = "control_line_end";
    static MOUSE_MOVING_MODE_CONTROL_CURVE = "control_curve";
    static MOUSE_MOVING_MODE_CONTROL_POLYGON = "control_polygon";
    static MOUSE_MOVING_MODE_SELECT_AREA = "select_area";
    mouseMovingMode = CanvasWindow.MOUSE_MOVING_MODE_NONE;
    selectedCurveControlPointIndex = 0;
    selectedPolygonControlPointIndex = 0;
    
    // マウス座標
    mouseStartX = 0;
    mouseStartY = 0;
    mouseCurrentX = 0;
    mouseCurrentY = 0;

    // 移動・リサイズ前のレイヤー情報
    srcLayerX = 0;
    srcLayerY = 0;
    srcLayerWidth = 0;
    srcLayerHeight = 0;
    srcLayerRotate = 0;
    srcControlPointX = 0;
    srcControlPointY = 0;
    srcTrimX = 0;
    srcTrimY = 0;
    srcTrimWidth = 100;
    srcTrimHeight = 100;
    // 複数レイヤー移動前のレイヤー情報
    // レイヤーid と位置のマッピング
    srcMultiLayersPositionMap : { [ key : string ] : { x : number, y : number } } = {};

    // テキストの選択状態
    srcTextSelectedLineIndex = 0;
    srcTextSelectedCharacterIndex = 0;
    srcTextIsAfterSelected = false;
    isTextSelecting = false;

    // ズーム対象のstyle
    svgWrapperStyle = {width: "", height: "", left: "",   top: "",   transform: ""};
    isFirst = true;
    // 連続したズーム処理のタイムアウト関数
    scrollTimeout;
    // 連続ズーム値変更前のスクロール位置
    scrollPosition = {left: 0, top: 0};
    // 連続ズーム値変更前のズーム値
    scrollBeforeScale = 0;
    // ズーム値変更前のズーム値
    oldScroll = {left: 0, top: 0};

    mounted() 
    {
        var canvasWindow = this.$refs.canvasWindow as Element;

        this.updateScaleFromPixels();
        this.autoResize();
        this.onLoad();

        window.addEventListener('resize', this.onResize);
        canvasWindow.addEventListener('scroll', () =>{
            if(this.svgWrapperStyle.left == "0"){
                this.oldScroll.left = canvasWindow.scrollLeft;
            }
            if(this.svgWrapperStyle.top == "0"){
                this.oldScroll.top = canvasWindow.scrollTop;
            }
            // if(!this.isAutoZoom){
            //     this.pointUpdate();
            // }
        });
    }

    destroyed()
    {
        // テキスト編集終了
        this.isTextInEdit = false;
        // 選択レイヤーのクリア
        this.$emit("doCommand", "changeCurrentLayer", { layer : null });
        // アンドゥリドゥマネージャの初期化
        this.$emit("doCommand", "initUndoRedo", null);
        window.removeEventListener("resize", this.onResize);
    }

    onLoad()
    {
        var canvasWindow = this.$refs.canvasWindow as Element;

        this.updateScaleFromPixels();
        this.adjustFrameSize();

        this.scrollPosition = {
            left: canvasWindow.scrollLeft,
            top: canvasWindow.scrollTop
        }
        this.scrollBeforeScale = this.zoomScale;
    }

    onResize()
    {
        // モバイルでは呼ばない
        return;

        this.updateScaleFromPixels();

        if(this.isAutoZoom)
        {
            this.autoResize();
        }
        this.$nextTick(() => {
            if(!this.isAutoZoom){
                this.zoomPositioning(this.zoomScale, this.zoomScale);
                this.autoZoomPositioning();
            }
        });
    }
    
    // svg全体の表示位置を修正する
    pointUpdate(){
        var canvasWindow = this.$refs.canvasWindow as Element;
        var svg = this.$refs.svg as Element;

        clearTimeout(this.scrollTimeout);

        this.scrollTimeout = setTimeout(() => {
            if(this.scrollBeforeScale == this.zoomScale){
                this.scrollPosition = {
                    left: canvasWindow.scrollLeft,
                    top: canvasWindow.scrollTop
                }
                return;
            }
            if(this.svgWrapperStyle.left == "0"){
                canvasWindow.scrollLeft = (this.scrollPosition.left + canvasWindow.clientWidth / 2) / this.scrollBeforeScale * this.zoomScale - canvasWindow.clientWidth / 2;
                this.scrollPosition.left = canvasWindow.scrollLeft;
            }else{
                this.scrollPosition.left = (svg.clientWidth - canvasWindow.clientWidth) / 2;
            }
            if(this.svgWrapperStyle.top == "0"){
                canvasWindow.scrollTop = (this.scrollPosition.top + canvasWindow.clientHeight / 2) / this.scrollBeforeScale * this.zoomScale - canvasWindow.clientHeight / 2;        
                this.scrollPosition.top = canvasWindow.scrollTop;
            }else{
                this.scrollPosition.top = (svg.clientHeight - canvasWindow.clientHeight) / 2;
            }

            this.scrollBeforeScale = this.zoomScale;
        }, 200);

    }

    private onDoCommand(command : string, paramater : any)
    {
        this.$emit("doCommand", command, paramater);
    }

    private updateScaleFromPixels()
    {
        this.$nextTick(()=>
        {
            var svg = this.getSvgElement();
            if(svg != null)
            {
                var clientWidth = svg.clientWidth > 0 ? svg.clientWidth : svg.getBoundingClientRect().width;
                var clientHeight = svg.clientHeight > 0 ? svg.clientHeight : svg.getBoundingClientRect().height;
                this.scaleFromPixels = Math.max(this.viewWidth / clientWidth, this.viewHeight / clientHeight);

                // カーソルサイズも更新する
                var cursorSize = window.innerWidth * 16 / 320 * this.scaleFromPixels;
                this.boundingBoxCursorSize = { width : cursorSize, height : cursorSize };
            }
        });
    }

    static readonly BOUNDING_BOX_CURSOR_WIDTH_PX = 12;
    static readonly BOUNDING_BOX_CURSOR_HEIGHT_PX = 12;
    static readonly TRIM_BOX_CURSOR_WIDTH_PX = 8;
    static readonly TRIM_BOX_CURSOR_HEIGHT_PX = 8;

    private boundingBoxCursorSize　: { width : number, height : number } = { width : 0, height : 0 };

    private get trimBoxCursorSize()
    {
        var width = CanvasWindow.TRIM_BOX_CURSOR_WIDTH_PX * this.scaleFromPixels;
        var height = CanvasWindow.TRIM_BOX_CURSOR_HEIGHT_PX * this.scaleFromPixels;
        return { width : width, height : height };
    }

    // キャンバス画像をpng(base64)として取得する
    // 常に最大の塗り足し幅まで作成する
    public getCanvasImageAsPng(completion : (image : string) => void )
    {
        // キャンバスのg要素を取得
        var canvas = this.$refs.canvas;
        // タグを取得
        var canvasTag = HtmlHelper.convertElementToTag(canvas);
        // 取り出す範囲
        var bleedRect = this.getBleedRectRotated(Const.BLEED_SIZE_MAX);
        // svgタグを追加して、指定範囲を取り出す
        var svgTagHeader = "<svg viewBox='" + bleedRect.x + " " + bleedRect.y + " " + bleedRect.width + " " + bleedRect.height + "' xmlns='http://www.w3.org/2000/svg'>";
        var svgTag = svgTagHeader + canvasTag + "</svg>";
        // レイヤー表示部をpngとして返す。
        var svgImage = ImageHelper.convertSVGTagToBase64(svgTag);
        ImageHelper.convertSVGImageToPng(svgImage, bleedRect.width, bleedRect.height, this.design.rotate, completion);
        // 対応していないCSSがあるので、このコンバートは使用しない
        //ImageHelper.convertSVGTagToPng(svgTag, this.viewWidth, this.viewHeight, completion);
    }
    
    // viewBox幅
    private get viewWidth() : number
    {
        return this.canvasWidth * CanvasWindow.CANVAS_OFFSET_FACTOR;
    }

    // viewBox高さ
    private get viewHeight() : number
    {
        return this.canvasHeight * CanvasWindow.CANVAS_OFFSET_FACTOR;
    }

    // viewBox
    private get viewBox() : string
    {
        return "0 0 " + this.viewWidth + " " + this.viewHeight;
    }

    // Canvas幅 *基準
    private get canvasWidth() : number
    {
        return UnitHelper.convert(this.design.width, "mm", "px");
    }

    // Canvas高さ *基準
    private get canvasHeight() : number
    {
        return UnitHelper.convert(this.design.height, "mm", "px");
    }

    // CanvasX
    private get canvasX() : number
    {
        return (this.viewWidth - this.canvasWidth) / 2;
    }

    // CanvasY
    private get canvasY() : number
    {
        return (this.viewHeight - this.canvasHeight) / 2;
    }

    // CanvasRadius
    private get canvasRadiusX() : number
    {
        return this.page.getSurface(this.isReverseSurface).getFrameRadius(this.page.currentDesignPosition) * this.scale;
    }
    private get canvasRadiusY() : number
    {
        return this.page.getSurface(this.isReverseSurface).getFrameRadius(this.page.currentDesignPosition) * this.scale;
    }

    // 内側の円を描画するか
    private get isInnerCircleVisible()
    {
        return this.page.getSurface(this.isReverseSurface).getFrameInnerCircleRadius(this.page.currentDesignPosition) > 0;
    }

    private get canvasInnerCX()
    {
        return this.canvasX + this.canvasWidth / 2;
    }

    private get canvasInnerCY()
    {
        return this.canvasY + this.canvasHeight / 2;
    }

    private get canvasInnerR()
    {
        return this.page.getSurface(this.isReverseSurface).getFrameInnerCircleRadius(this.page.currentDesignPosition) * this.scale;
    }

    // frameImage
    private get frameImageSource() : string
    {
        return this.page.getSurface(this.isReverseSurface).getFrameImage(this.page.currentDesignPosition);
    }

    // frameImageは用紙全体のものなので、編集中のフレームにフォーカスする
    private get frameTransform() : string
    {
        var transform = "";

        // 回転角は (ドキュメントの回転角) + (デザインの回転角)
        // var totalRotate = this.design.rotate + this.documentRotate;
        // while(totalRotate < 0) { totalRotate += 360; }
        // while(totalRotate >= 360) { totalRotate -= 360; }
        
        // オフセット
        // まずキャンバス位置までオフセットして、回転角ごと適切な位置補正を加える
        var designRect = this.page.getSurface(this.isReverseSurface).getDesignRect(this.page.currentDesignPosition);
        var dx = 0;
        var dy = 0;
        if(this.design.rotate == 90)
        {
            dx = (designRect.y + designRect.height) * this.scale;
            dy = -designRect.x * this.scale;
        }
        else if(this.design.rotate == 180)
        {
            dx = (designRect.x + designRect.width) * this.scale;
            dy = (designRect.y + designRect.height) * this.scale;
        }
        else if(this.design.rotate == 270)
        {
            dx = -designRect.y * this.scale;
            dy = (designRect.x + designRect.width) * this.scale;
        }
        else 
        {
            dx = -designRect.x * this.scale;
            dy = -designRect.y * this.scale;
        }
        var offsetX = this.canvasX + dx;
        var offsetY = this.canvasY + dy;
        transform += "translate(" + offsetX + " " + offsetY + "),";

        // キャンバス回転角で回転
        transform += "rotate(" + this.design.rotate + "),";

        dx = 0;
        dy = 0;
        if(this.documentRotate == 90)
        {
            dx = UnitHelper.convert(this.page.width, "mm", "px");
        }
        else if(this.documentRotate == 180)
        {
            dx = UnitHelper.convert(this.page.width, "mm", "px");
            dy = UnitHelper.convert(this.page.height, "mm", "px");
        }
        else if(this.documentRotate == 270)
        {
            dy = UnitHelper.convert(this.page.height, "mm", "px");
        }

        transform += "translate(" + dx + " " + dy + "),";

        // ドキュメント回転角で回転
        transform += "rotate(" + this.documentRotate + "),";

        // スケーリング
        // 拡大率は (イメージ幅 / デザイン幅) , (イメージ高さ / デザイン高さ)
        var imageWidth = this.documentRotate == 90 || this.documentRotate == 270 ? this.page.height : this.page.width;
        var imageHeight = this.documentRotate == 90 || this.documentRotate == 270 ? this.page.width : this.page.height;
        var scaleX = imageWidth / this.design.width;
        var scaleY = imageHeight / this.design.height;
        transform += "scale(" + scaleX + " " + scaleY + ")";
        
        return transform;
    }

    private get frameClipRect() : Rectangle
    {
        // フレームクリップ領域
        var designRect = this.page.getSurface(this.isReverseSurface).getDesignRect(this.page.currentDesignPosition);
        var x = 0;
        var y = 0;
        var w = 0;
        var h = 0;
        // designRectは回転が考慮されているので、ドキュメント回転角によりクリップ範囲を変化させる
        if(this.documentRotate == 90)
        {
            x = designRect.y / this.page.height;
            y = (this.page.width - designRect.x - designRect.width) / this.page.width;
            w = designRect.height / this.page.height;
            h = designRect.width / this.page.width;
        }
        else if(this.documentRotate == 180)
        {
            x = (this.page.width - designRect.x - designRect.width) / this.page.width;
            y = (this.page.height - designRect.y - designRect.height) / this.page.height;
            w = designRect.width;
            h = designRect.height;
        }
        else if(this.documentRotate == 270)
        {
            x = (this.page.height - designRect.y - designRect.height) / this.page.height;
            y = designRect.x / this.page.width;
            w = designRect.height / this.page.height;
            h = designRect.width / this.page.width;
        }
        else
        {
            x = designRect.x / this.page.width;
            y = designRect.y / this.page.height;
            w = designRect.width / this.page.width;
            h = designRect.height / this.page.height;
        }

        return new Rectangle(x, y, w, h);
    }

    // 塗り足しサイズ
    private getBleedSize()
    {
        return this.$store.getters.userConfig.bleedSize;
    }

    // 塗り足し枠を回転を考慮して取得する
    private getBleedRectRotated(bleedSize : number)
    {
        var bleedRect = this.page.getSurface(this.isReverseSurface).getBleedRect(this.page.currentDesignPosition, bleedSize);
        var designRect = this.page.getSurface(this.isReverseSurface).getDesignRect(this.page.currentDesignPosition);
        var x = 0;
        var y = 0;
        var w = 0;
        var h = 0;
        if(this.design.rotate == 90)
        {
            x = this.canvasX - (bleedRect.bottom - designRect.bottom) * this.scale;
            y = this.canvasY + (bleedRect.x - designRect.x) * this.scale;
            w = bleedRect.height * this.scale;
            h = bleedRect.width * this.scale;
        }
        else if(this.design.rotate == 180)
        {
            x = this.canvasX - (bleedRect.right - designRect.right) * this.scale;
            y = this.canvasY - (bleedRect.bottom - designRect.bottom) * this.scale;
            w = bleedRect.width * this.scale;
            h = bleedRect.height * this.scale;
        }
        else if(this.design.rotate == 270)
        {
            x = this.canvasX + (bleedRect.y - designRect.y) * this.scale;
            y = this.canvasY - (bleedRect.right - designRect.right) * this.scale;
            w = bleedRect.height * this.scale;
            h = bleedRect.width * this.scale;
        }
        else
        {
            x = this.canvasX + (bleedRect.x - designRect.x) * this.scale;
            y = this.canvasY + (bleedRect.y - designRect.y) * this.scale;
            w = bleedRect.width * this.scale;
            h = bleedRect.height * this.scale;
        }

        return new Rectangle(x, y , w, h);
    }

    // 塗り足し幅
    private get bleedWidth() : number
    {
        return this.getBleedRectRotated(this.getBleedSize()).width;
    }

    // 塗り足し高さ
    private get bleedHeight() : number
    {
        return this.getBleedRectRotated(this.getBleedSize()).height;
    }

    // 塗り足しX
    private get bleedX() : number
    {
        return this.getBleedRectRotated(this.getBleedSize()).x;
    }

    // 塗り足しY
    private get bleedY() : number
    {
        return this.getBleedRectRotated(this.getBleedSize()).y;
    }

    // Area Selector
    private get selectX()
    {
        // マウス座標 -> SVG座標
        var startX = this.toSVGPointFromClient(this.mouseStartX, this.mouseStartY).x;
        var currentX = this.toSVGPointFromClient(this.mouseCurrentX, this.mouseCurrentY).x;
        return Math.min(startX, currentX);
    }

    private get selectY()
    {
        // マウス座標 -> SVG座標
        var startY = this.toSVGPointFromClient(this.mouseStartX, this.mouseStartY).y;
        var currentY = this.toSVGPointFromClient(this.mouseCurrentX, this.mouseCurrentY).y ;
        return Math.min(startY, currentY);
    }

    private get selectWidth()
    {
        // マウス座標 -> SVG座標
        var startX = this.toSVGPointFromClient(this.mouseStartX, this.mouseStartY).x;
        var currentX = this.toSVGPointFromClient(this.mouseCurrentX, this.mouseCurrentY).x;
        return Math.abs(startX - currentX);
    }

    private get selectHeight()
    {
        // マウス座標 -> SVG座標
        var startY = this.toSVGPointFromClient(this.mouseStartX, this.mouseStartY).y;
        var currentY = this.toSVGPointFromClient(this.mouseCurrentX, this.mouseCurrentY).y;
        return Math.abs(startY - currentY);
    }

    public get allLayers() : Layer[]
    {
        return this.design.getAllLayers();
    }

    public get layer() : Layer
    {
        return this.design.layer;
    }

    public get currentLayer() : Layer | null
    {
        return this.design.currentLayer;
    }

    public get selectLayers()
    {
        return this.design.getSelectLayerWithoutGroup();
    }

    public getSelectLayerBorderPoints(layer : Layer)
    {
        var points = "";
        for(var i = 0; i < layer.getVertexes().length; ++i)
        {
            if(i > 0) { points += " "; }
            var ver = layer.getVertexes()[i];
            points += (ver.x * this.scale + this.canvasX) + "," + (ver.y * this.scale + this.canvasY);
        }
        return points;
    }

    public get scale() : number
    {
        return UnitHelper.convert(1, "mm", "px");
    }

    public scaleFromPixels : number = 0;

    private get scaleFromSvg() : number
    {
        if(this.scaleFromPixels > 0)
        {
            return 1 / this.scaleFromPixels;
        }
        else
        {
            return 1;
        }
    }

    private getSvgElement() : SVGSVGElement | null
    {
        if(this.$refs.svg == null) { return null; }
        return this.$refs.svg as SVGSVGElement;
    }

    // 選択レイヤー枠表示条件
    private get selectLayerBorderVisible()
    {
        if(this.design.selectLayers.length == 1 && this.design.selectLayers[0].layerType == "group")
        {
            // 選択レイヤーがただ一つで、かつグループレイヤーの場合は選択レイヤーを表示しない
            return false;
        }

        // グループを除いた全選択レイヤーが複数
        var allSelectedLayers = this.design.getSelectLayerWithoutGroup();
        return allSelectedLayers.length > 1;
    }

    // バウンディングボックスの表示条件
    private get boundingBoxVisible()
    {
        // 選択レイヤー枠が表示されている場合は表示しない
        if(this.selectLayerBorderVisible) { return false; }
        // グループを除いた全選択レイヤーが0のときは表示しない
        if(this.design.getSelectLayerWithoutGroup().length == 0) { return false; }
        var editMode = this.$store.getters.applicationState.editMode;
        return this.currentLayer != null && this.currentLayer.layerType != "line" && this.currentLayer.layerType != "curve" && editMode == 0;
    }

    // 直線レイヤーコントローラの表示条件
    private get lineControllerVisible()
    {
        return this.currentLayer != null && this.currentLayer.layerType == "line";
    }

    // 曲線レイヤーコントローラの表示条件
    private get curveControllerVisible()
    {
        return this.currentLayer != null && this.currentLayer.layerType == "curve";
    }

    // 多角形レイヤーコントローラの表示条件
    private get polygonControllerVisible()
    {
        var editMode = this.$store.getters.applicationState.editMode;
        return this.currentLayer != null && this.currentLayer.layerType == "polygon" && (editMode == 1 || editMode == 2 || editMode == 3);
    }

    // トリミングボックスの表示条件
    private get trimBoxVisible()
    {
        var editMode = this.$store.getters.applicationState.editMode;
        return this.currentLayer != null && (this.currentLayer.layerType == "rasterImage" || this.currentLayer.layerType == "vectorImage") && editMode == 4;
    }

    // サイズコントローラの表示条件
    private get sizeControllerVisible()
    {
        return this.currentLayer != null && this.currentLayer.layerType != "curve" && this.currentLayer.layerType != "line";
    }

    // エリア選択矩形の表示条件
    private get isSelectArea()
    {
        return this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_SELECT_AREA;
    }

    // eventHandler
    private onBoundingBoxCursorSelected(cursor : string)
    {
        // マウス移動時の動作変更
        if(cursor == "top_left") { this.mouseMovingMode = CanvasWindow.MOUSE_MOVING_MODE_RESIZE_FROM_BOTTOM_RIGHT; }
        else if(cursor == "left") { this.mouseMovingMode = CanvasWindow.MOUSE_MOVING_MODE_RESIZE_FROM_RIGHT; }
        else if(cursor == "bottom_left") { this.mouseMovingMode = CanvasWindow.MOUSE_MOVING_MODE_RESIZE_FROM_TOP_RIGHT; }
        else if(cursor == "bottom") { this.mouseMovingMode = CanvasWindow.MOUSE_MOVING_MODE_RESIZE_FROM_TOP; }
        else if(cursor == "bottom_right") { this.mouseMovingMode = CanvasWindow.MOUSE_MOVING_MODE_RESIZE_FROM_TOP_LEFT; }
        else if(cursor == "right") { this.mouseMovingMode = CanvasWindow.MOUSE_MOVING_MODE_RESIZE_FROM_LEFT; }
        else if(cursor == "top_right") { this.mouseMovingMode = CanvasWindow.MOUSE_MOVING_MODE_RESIZE_FROM_BOTTOM_LEFT; }
        else if(cursor == "top") { this.mouseMovingMode = CanvasWindow.MOUSE_MOVING_MODE_RESIZE_FROM_BOTTOM; }
        else if(cursor == "rotate") { this.mouseMovingMode = CanvasWindow.MOUSE_MOVING_MODE_ROTATE; }
    }

    private onTrimBoxCursorSelected(cursor : string)
    {
        // マウス移動時の動作変更
        if(cursor == "top_left") { this.mouseMovingMode = CanvasWindow.MOUSE_MOVING_MODE_RESIZE_FROM_BOTTOM_RIGHT; }
        else if(cursor == "left") { this.mouseMovingMode = CanvasWindow.MOUSE_MOVING_MODE_RESIZE_FROM_RIGHT; }
        else if(cursor == "bottom_left") { this.mouseMovingMode = CanvasWindow.MOUSE_MOVING_MODE_RESIZE_FROM_TOP_RIGHT; }
        else if(cursor == "bottom") { this.mouseMovingMode = CanvasWindow.MOUSE_MOVING_MODE_RESIZE_FROM_TOP; }
        else if(cursor == "bottom_right") { this.mouseMovingMode = CanvasWindow.MOUSE_MOVING_MODE_RESIZE_FROM_TOP_LEFT; }
        else if(cursor == "right") { this.mouseMovingMode = CanvasWindow.MOUSE_MOVING_MODE_RESIZE_FROM_LEFT; }
        else if(cursor == "top_right") { this.mouseMovingMode = CanvasWindow.MOUSE_MOVING_MODE_RESIZE_FROM_BOTTOM_LEFT; }
        else if(cursor == "top") { this.mouseMovingMode = CanvasWindow.MOUSE_MOVING_MODE_RESIZE_FROM_BOTTOM; }
        else if(cursor == "rotate") { this.mouseMovingMode = CanvasWindow.MOUSE_MOVING_MODE_ROTATE; }
    }

    private onBoundingBoxFrameSelected()
    {
        // マウス移動時の動作変更
        this.mouseMovingMode = CanvasWindow.MOUSE_MOVING_MODE_MOVE;
    }

    private onSelectStartPoint()
    {
        this.mouseMovingMode = CanvasWindow.MOUSE_MOVING_MODE_CONTROL_LINE_START;
    }

    private onSelectEndPoint()
    {
        this.mouseMovingMode = CanvasWindow.MOUSE_MOVING_MODE_CONTROL_LINE_END;
    }

    private onSelectCurvePoint(index)
    {
        this.mouseMovingMode = CanvasWindow.MOUSE_MOVING_MODE_CONTROL_CURVE;
        this.selectedCurveControlPointIndex = index;
    }

    private onSelectPolygonPoint(index)
    {
        this.mouseMovingMode = CanvasWindow.MOUSE_MOVING_MODE_CONTROL_POLYGON;
        this.selectedPolygonControlPointIndex = index;
    }

    private onSelectSizePoint()
    {
        this.mouseMovingMode = CanvasWindow.MOUSE_MOVING_MODE_RESIZE_FROM_TOP_LEFT;
    }

    private isPinch = false;
    private isPan = false;
    private baseDistance = 0;
    private baseLayerWidth = 0;
    private baseLayerHeight = 0;
    private baseLayerX = 0;
    private baseLayerY = 0;
    private baseTouchX = 0;
    private baseTouchY = 0;
    private baseZoomScale = 0;

    private onTouchMove(event : TouchEvent) 
    {
        var currentLayer = this.design.currentLayer;

        var touches = event.touches;
        if(touches.length > 1)
        {
            // 指２本はズーム操作
            var x1 = touches[0].clientX;
            var y1 = touches[0].clientY;
            var x2 = touches[1].clientX;
            var y2 = touches[1].clientY;

            var distance = Math.sqrt((x1 - x2) * (x1 - x2) + (y1 - y2) * (y1 - y2));
            
            //! レイヤーの拡大・縮小は行わない
            // if(currentLayer != null && currentLayer.layerType != "line" && currentLayer.layerType != "curve")
            // {
            //     if(this.isPinch)
            //     {
            //         var scale = distance / this.baseDistance;
            //         if(scale > 0 && scale != Infinity)
            //         {
            //             // 拡大縮小チェック
            //             var keepRatio = 0;
            //             if(currentLayer["keepRatio"] != null && typeof(currentLayer["keepRatio"]) == "number")
            //             {
            //                 keepRatio = currentLayer["keepRatio"];
            //             }
            //             // 幅は縦横固定・縦固定のときのみ
            //             var newWidth = keepRatio == 0 || keepRatio == 1 ? this.baseLayerWidth * scale : this.baseLayerWidth;
            //             // 高さは縦横固定、横固定のときのみ
            //             var newHeight = keepRatio == 0 || keepRatio == 2 ? this.baseLayerHeight * scale : this.baseLayerHeight;
            //             // 移動モード
            //             this.$store.getters.applicationState.moveLayerMode = 2;
            //             this.$store.getters.applicationState.moveLayerId = currentLayer.id;
            //             this.$emit("doCommand", "scaleLayer", { layer : currentLayer, width : newWidth, height : newHeight, isFinish : false });
            //         }
            //     }
            //     else
            //     {
            //         this.baseLayerWidth = currentLayer.width;
            //         this.baseLayerHeight = currentLayer.height;
            //         this.baseDistance = distance;
            //         this.isPinch = true;
            //         this.isPan = false;
            //     }
            // }
            // else
            {
                if(this.isPinch)
                {
                    var scale = distance / this.baseDistance;
                    if(scale > 0 && scale != Infinity)
                    {
                        this.$emit("doCommand", "changeZoomScale", { scale : this.baseZoomScale * scale, isAutoZoomOff : true });
                    }
                }
                else
                {
                    this.baseZoomScale = this.zoomScale;  
                    this.baseDistance = distance;
                    this.isPinch = true;
                    this.isPan = false; 
                }
            }

            // デフォルトの動作をオフ
            event.preventDefault();
        }
        else if(touches.length == 1)
        {
            if(currentLayer != null)
            {
                // 指１本は移動操作
                var x1 = touches[0].clientX;
                var y1 = touches[0].clientY;

                if(this.isPan)
                {
                    // 移動差分
                    var currentPos = this.toDesignPointFromClient(x1, y1);
                    var startPos = this.toDesignPointFromClient(this.baseTouchX, this.baseTouchY);
                    var deltaX = currentPos.x - startPos.x;
                    var deltaY = currentPos.y - startPos.y;

                    if(this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_CONTROL_LINE_START)
                    {
                        // 直線レイヤーの始点変更
                        var newX = this.baseLayerX + deltaX;
                        var newY = this.baseLayerY + deltaY;
                        this.$emit("doCommand", "changeLayerProperty", { layer : this.currentLayer, propertyName : "startX", value : newX, isFinish : false });
                        this.$emit("doCommand", "changeLayerProperty", { layer : this.currentLayer, propertyName : "startY", value : newY, isFinish : false });
                    }
                    else if(this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_CONTROL_LINE_END)
                    {
                        // 直線レイヤーの終点変更
                        var newX = this.baseLayerX + this.baseLayerWidth + deltaX;
                        var newY = this.baseLayerY + this.baseLayerHeight + deltaY;
                        this.$emit("doCommand", "changeLayerProperty", { layer : this.currentLayer, propertyName : "endX", value : newX, isFinish : false });
                        this.$emit("doCommand", "changeLayerProperty", { layer : this.currentLayer, propertyName : "endY", value : newY, isFinish : false });
                    }
                    else if(this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_CONTROL_CURVE)
                    {
                        // 曲線レイヤーの制御点変更
                        var newControlPointX = this.srcControlPointX + deltaX;
                        var newControlPointY = this.srcControlPointY + deltaY;
                        this.$emit("doCommand", "moveCurveControlPoint", { layer : this.currentLayer, index : this.selectedCurveControlPointIndex, x : newControlPointX, y : newControlPointY, isFinish : false });
                    }
                    else if(this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_RESIZE_FROM_TOP_LEFT)
                    {
                        // レイヤーの拡大・縮小(左上基準)
                        var dstWidth = this.baseLayerWidth + deltaX;
                        var dstHeight = this.baseLayerHeight + deltaY;
                        // 縦横固定チェック
                        if(currentLayer["keepRatio"] != null && currentLayer["keepRatio"] == 0 && this.baseLayerWidth != 0 && this.baseLayerHeight != 0)
                        {
                            // 比率固定する
                            var dScaleX = dstWidth / this.baseLayerWidth;
                            var dScaleY = dstHeight / this.baseLayerHeight;
                            if(dScaleX * dScaleX > dScaleY * dScaleY)
                            {
                                dstWidth = this.baseLayerWidth * dScaleY;
                            }
                            else
                            {
                                dstHeight = this.baseLayerHeight * dScaleX;
                            }
                        }
                        this.$emit("doCommand", "transformLayer", { layer : currentLayer, 
                            x : currentLayer.x, y : currentLayer.y, width : dstWidth, height : dstHeight, rotate : currentLayer.rotate, isFinish : false });
                    }
                    else
                    {
                        // 移動モード
                        this.$store.getters.applicationState.moveLayerMode = 1;
                        this.$store.getters.applicationState.moveLayerId = currentLayer.id;
                        // 移動イベントを投げる
                        this.$emit("doCommand", "moveLayer", { layer : currentLayer, x : this.baseLayerX + deltaX , y : this.baseLayerY + deltaY, isFinish : false });
                    }
                }
                else
                {
                    this.baseTouchX = x1;
                    this.baseTouchY = y1;
                    this.baseLayerX = currentLayer.x;
                    this.baseLayerY = currentLayer.y;
                    this.baseLayerWidth = currentLayer.width;
                    this.baseLayerHeight = currentLayer.height;
                    this.isPan = true;
                    this.isPinch = false;
                    if(this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_CONTROL_CURVE && this.currentLayer instanceof CurveLayer)
                    {
                        // 制御点移動のために情報保持
                        var controlPoint = this.currentLayer.getControlPoint(this.selectedCurveControlPointIndex);
                        this.srcControlPointX = controlPoint.x;
                        this.srcControlPointY = controlPoint.y;
                    }
                }

                // デフォルトの動作をオフ
                event.preventDefault();
            }
        }
    }

    private onTouchEnd(event : TouchEvent)
    {
        this.isPinch = false;
        this.isPan = false;

        this.$emit("doCommand", "fixMultiCommand", null);
        this.mouseMovingMode = CanvasWindow.MOUSE_MOVING_MODE_NONE;

        // 移動モード
        this.$store.getters.applicationState.moveLayerMode = 0;
        this.$store.getters.applicationState.moveLayerId = "";
    }

    private onTouchStart(event : TouchEvent)
    {
        // ポップアップ上でタッチムーブ中はイベントをキャンセルする
        if(this.popupTouchState == "move")
        {
            event.preventDefault();
            return;
        }

        var touches = event.touches;
        if(touches.length == 1 && this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_NONE)
        {
            // クライアント座標をデザイン座標系に変換
            var pos = this.toDesignPointFromClient(touches[0].clientX, touches[0].clientY);
            // タッチ位置にあるレイヤーを調べ、最前面のレイヤーを返す
            var foundLayers = this.design.getLayersFromPosition(pos.x, pos.y, false, true);
            var targetLayer = foundLayers.length > 0 ? foundLayers[foundLayers.length - 1] : null;
            
            var currentLayer = this.design.currentLayer;
            if(currentLayer != targetLayer)
            {
                // このレイヤーを選択状態にする
                this.$emit("doCommand", "changeCurrentLayer", { layer : targetLayer });
            }

            if(currentLayer != null)
            {
                event.preventDefault();
            }
        }

        // タッチを感知したら、ポップアップを消去する
        this.$emit("doCommand", "hidePopupController", null);
    }

    private onMouseDown(event : MouseEvent)
    {
        // マウス座標保持
        this.mouseStartX = event.clientX;
        this.mouseStartY = event.clientY;

        // 操作点変更操作を行ったか?
        var isChangedControlPoint = false;

        if(this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_NONE)
        {
            // カーソルが選ばれなかったとき

            // マウス座標をデザイン座標系に変換
            var xInDesign = this.toDesignPointFromClient(event.clientX, event.clientY).x;
            var yInDesign = this.toDesignPointFromClient(event.clientX, event.clientY).y;

            DebugHelper.trace(event.clientX)
            DebugHelper.trace(event.clientY)

            // マウス位置にあるレイヤーを調べ、最前面のレイヤーを返す
            var foundLayers = this.design.getLayersFromPosition(xInDesign, yInDesign);
            var targetLayer : Layer | null = foundLayers.length > 0 ? foundLayers[foundLayers.length - 1] : null;

            if (targetLayer && event.shiftKey) {
                if (this.design.selectLayers.includes(targetLayer)) {
                    this.$emit('doCommand', 'removeLayerSelection', { layer: targetLayer })
                }
                else {
                    this.$emit('doCommand', 'appendLayerSelection', { layer: targetLayer });
                }
                return;
            }

            // 選択レイヤーにターゲットレイヤーが含まれているか調べる(ただし選択レイヤーが複数の時)
            var isTargetSelected = false;
            var selectLayers = this.design.getSelectLayerWithoutGroup();
            if(this.design.getSelectLayerWithoutGroup().length > 1)
            {
                for(var i = 0; i < selectLayers.length; ++i)
                {
                    if(targetLayer == selectLayers[i])
                    {
                        isTargetSelected = true;
                        break;
                    }
                }
            }
            if(isTargetSelected)
            {
                // 選択レイヤーにターゲットレイヤーが含まれている

                // テキスト編集モードを解除
                if(this.isTextInEdit)
                {
                    // テキスト編集中だった場合はテキスト編集を確定する
                    this.fixMultiCommand();
                }
                this.isTextInEdit = false;

                // 複数レイヤー移動
                this.mouseMovingMode = CanvasWindow.MOUSE_MOVING_MODE_MOVE_MULTI;

                // レイヤー情報保持
                for(var i = 0; i < selectLayers.length; ++i)
                {
                    var selectLayer = selectLayers[i];
                    this.srcMultiLayersPositionMap[selectLayer.id] = { x : selectLayer.x, y : selectLayer.y };
                }

                return;
            }

            if(this.currentLayer == targetLayer)
            {
                if(targetLayer != null)
                {
                    // 同一レイヤーがクリックされた
                    if(targetLayer instanceof TextLayer)
                    {
                        // ターゲットがテキストレイヤー or 表レイヤーの場合は、編集モード
                        this.isTextInEdit = true;

                        if(targetLayer instanceof TextLayer)
                        {
                            // この時点でのテキスト選択位置を保持する
                            this.srcTextSelectedLineIndex = targetLayer.selectedLineIndex;
                            this.srcTextSelectedCharacterIndex = targetLayer.selectedCharacterIndex;
                            this.srcTextIsAfterSelected = targetLayer.isAfterSelected;
                            // テキスト選択中フラグ
                            this.isTextSelecting = true;
                        }
                    }
                    else if(targetLayer instanceof CurveLayer && this.$store.getters.applicationState.curveEditMode == 2)
                    {
                        // ターゲットが曲線レイヤー、かつ追加モード
                        // 曲線に制御点を追加する
                        this.$emit("doCommand", "addControlPointToCurve", { layer : targetLayer, index : targetLayer.lastTouchedIndex + 1, x : xInDesign, y : yInDesign });
                        isChangedControlPoint = true;
                    }
                    else if(targetLayer instanceof PolygonLayer && this.$store.getters.applicationState.editMode == 2 && targetLayer.isTouchedOnLine)
                    {
                        // ターゲットが多角形レイヤー、かつ追加モードで辺の上にいる
                        // 多角形に制御点を追加する
                        var points = new Array();
                        for(var i = 0; i < targetLayer.getControlPointsNumber(); ++i)
                        {
                            var point = targetLayer.getRotatedControlPoint(i);
                            points.push(point);
                            if(i == targetLayer.lastTouchedLineStartIndex)
                            {
                                // ここに追加
                                points.push(new Vector2(xInDesign, yInDesign));
                            }
                        }

                        this.$emit("doCommand", "applyPolygonControlPoints", { layer : this.currentLayer, points : points });
                        isChangedControlPoint = true;
                    }
                    else
                    {
                        // レイヤー移動
                        this.mouseMovingMode = CanvasWindow.MOUSE_MOVING_MODE_MOVE;
                    }
                }
            }
            else
            {
                // 別のレイヤーがクリックされた or レイヤーのカレントが外れた
                // テキスト編集モードを解除
                if(this.isTextInEdit)
                {
                    // テキスト編集中だった場合はテキスト編集を確定する
                    this.fixMultiCommand();
                }
                this.isTextInEdit = false;

                // カレントレイヤー変更コマンド呼び出し
                this.$emit("doCommand", "changeCurrentLayer", { layer : targetLayer });

                if(targetLayer instanceof TextLayer)
                {
                    // ターゲットがテキストレイヤーの場合は、編集モード
                    this.isTextInEdit = true;

                    if(targetLayer instanceof TextLayer)
                    {
                        // この時点でのテキスト選択位置を保持する
                        this.srcTextSelectedLineIndex = targetLayer.selectedLineIndex;
                        this.srcTextSelectedCharacterIndex = targetLayer.selectedCharacterIndex;
                        this.srcTextIsAfterSelected = targetLayer.isAfterSelected;
                        // テキスト選択中フラグ
                        this.isTextSelecting = true;
                    }
                }
                else
                {
                    // レイヤー移動
                    this.mouseMovingMode = CanvasWindow.MOUSE_MOVING_MODE_MOVE;
                }
            }
        }
        else
        {
            // カーソルが選ばれた
            
            // テキスト編集モードは外す。レイヤー拡大縮小がしづらくなるため
            if(this.isTextInEdit)
            {
                // テキスト編集中だった場合はテキスト編集を確定する
                this.fixMultiCommand();
            }
            this.isTextInEdit = false;

            if(this.currentLayer instanceof TableLayer)
            {
                // 表だった場合セルの選択状態をクリア
                this.currentLayer.currentRow = -1;
                this.currentLayer.currentColumn = -1;
            }
        }

        if(this.currentLayer != null)
        {
            // レイヤー情報保持
            this.srcLayerX = this.currentLayer.x;
            this.srcLayerY = this.currentLayer.y;
            this.srcLayerWidth = this.currentLayer.width;
            this.srcLayerHeight = this.currentLayer.height;
            this.srcLayerRotate = this.currentLayer.rotate;
            if(this.currentLayer instanceof ImageLayer)
            {
                this.srcTrimX = this.currentLayer.trimRectNormalized.x;
                this.srcTrimY = this.currentLayer.trimRectNormalized.y;
                this.srcTrimWidth = this.currentLayer.trimRectNormalized.width;
                this.srcTrimHeight = this.currentLayer.trimRectNormalized.height;
            }

            if(this.currentLayer instanceof CurveLayer && this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_CONTROL_CURVE)
            {
                // 曲線レイヤの制御点が選ばれた
                if(this.$store.getters.applicationState.curveEditMode == 3)
                {
                    // 制御点削除
                    if(this.currentLayer.getControlPointsNumber() > 2)
                    {
                        // 3点以上制御点がある場合は削除可能
                        this.$emit("doCommand", "removeControlPointFromCurve", { layer : this.currentLayer, index : this.selectedCurveControlPointIndex });
                        isChangedControlPoint = true;
                    }
                    // 制御点移動をキャンセル
                    this.mouseMovingMode = CanvasWindow.MOUSE_MOVING_MODE_NONE;
                }
                else
                {
                    // 制御点移動のために情報保持
                    var controlPoint = this.currentLayer.getControlPoint(this.selectedCurveControlPointIndex);
                    this.srcControlPointX = controlPoint.x;
                    this.srcControlPointY = controlPoint.y;
                }
            }
            else if(this.currentLayer instanceof PolygonLayer && this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_CONTROL_POLYGON)
            {
                // 多角形レイヤの制御点が選ばれた
                if(this.$store.getters.applicationState.editMode == 3)
                {
                    // 制御点削除
                    if(this.currentLayer.getControlPointsNumber() > 3)
                    {
                        // 4点以上制御点がある場合は削除可能
                        // 新しい表示上の操作点を求める
                        var points = new Array();
                        for(var i = 0; i < this.currentLayer.getControlPointsNumber(); ++i)
                        {
                            if(i == this.selectedPolygonControlPointIndex) { continue; }
                            var p = this.currentLayer.getRotatedControlPoint(i);
                            points.push(p);
                        }
                        this.$emit("doCommand", "applyPolygonControlPoints", { layer : this.currentLayer, points : points });
                        isChangedControlPoint = true;
                    }
                    // 制御点移動をキャンセル
                    this.mouseMovingMode = CanvasWindow.MOUSE_MOVING_MODE_NONE;
                }
                else
                {
                    // 制御点移動のために情報保持
                    var controlPoint = this.currentLayer.getRotatedControlPoint(this.selectedPolygonControlPointIndex);
                    this.srcControlPointX = controlPoint.x;
                    this.srcControlPointY = controlPoint.y;
                }
            }
        }
        else
        {
            // エリア選択モードに切り替え
            this.mouseMovingMode = CanvasWindow.MOUSE_MOVING_MODE_SELECT_AREA;
        }

        if(this.isTextInEdit)
        {
            // フォーカス
            var editor = this.$refs.textEditor as TextEditor;
            if(editor != null) { editor.focus(); }
        }
        else if(this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_NONE || this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_SELECT_AREA)
        {
            if(!isChangedControlPoint)
            {
                // モードなしorエリア選択モードのとき、選択レイヤーをクリアする
                // ただし、制御点の編集を行った場合はこの処理をしない。
                this.$emit("doCommand", "changeCurrentLayer", { layer : null });
            }
        }
    }

    private onMouseMove(event : MouseEvent)
    {
        // マウス座標取得
        this.mouseCurrentX = event.clientX;
        this.mouseCurrentY = event.clientY;
        if(this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_MOVE_MULTI)
        {
            var currentMouse = this.toDesignPointFromClient(event.clientX, event.clientY);
            var beforeMouse = this.toDesignPointFromClient(this.mouseStartX, this.mouseStartY);
            var deltaXInDesign = currentMouse.x - beforeMouse.x;
            var deltaYInDesign = currentMouse.y - beforeMouse.y;

            // 複数レイヤーの移動
            var selectLayers = this.design.getSelectLayerWithoutGroup();
            for(var i = 0; i < selectLayers.length; ++i)
            {
                var selectLayer = selectLayers[i];
                if(this.srcMultiLayersPositionMap[selectLayer.id])
                {
                    var newX = this.srcMultiLayersPositionMap[selectLayer.id].x + deltaXInDesign;
                    var newY = this.srcMultiLayersPositionMap[selectLayer.id].y + deltaYInDesign;
                    // 変形コマンド発行を継続で送る
                    this.$emit("doCommand", "transformLayer", { layer : selectLayer, 
                        x : newX, y : newY, width : selectLayer.width, height : selectLayer.height, 
                        rotate : selectLayer.rotate, isFinish : false });
                }
            }
        }
        else if(this.mouseMovingMode != CanvasWindow.MOUSE_MOVING_MODE_NONE && this.currentLayer != null)
        {
            var currentMouse = this.toDesignPointFromClient(event.clientX, event.clientY);
            var beforeMouse = this.toDesignPointFromClient(this.mouseStartX, this.mouseStartY);
            var deltaXInDesign = currentMouse.x - beforeMouse.x;
            var deltaYInDesign = currentMouse.y - beforeMouse.y;

            // トリミング対応
            if(this.trimBoxVisible)
            {
                // レイヤーの回転角を元にベクトルを分解
                var vector = new Vector2(deltaXInDesign, deltaYInDesign).getResolutionDegrees(this.currentLayer.rotate);
                if(!MathHelper.equals(this.currentLayer.width, 0) && !MathHelper.equals(this.currentLayer.height, 0))
                {
                    var dstTrimX = this.srcTrimX;
                    var dstTrimY = this.srcTrimY;
                    var dstTrimWidth = this.srcTrimWidth;
                    var dstTrimHeight = this.srcTrimHeight;

                    if(this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_RESIZE_FROM_TOP_LEFT)
                    {
                        // 左上固定
                        dstTrimWidth = this.srcTrimWidth + vector.x / this.currentLayer.width * 100;
                        dstTrimHeight = this.srcTrimHeight + vector.y / this.currentLayer.height * 100;
                    }
                    else if(this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_RESIZE_FROM_LEFT)
                    {
                        // 左固定
                        dstTrimWidth = this.srcTrimWidth + vector.x / this.currentLayer.width * 100;
                    }
                    else if(this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_RESIZE_FROM_BOTTOM_LEFT)
                    {
                        // 左下固定
                        dstTrimY = this.srcTrimY + vector.y / this.currentLayer.height * 100;
                        dstTrimWidth = this.srcTrimWidth + vector.x / this.currentLayer.width * 100;
                        dstTrimHeight = this.srcTrimHeight - vector.y / this.currentLayer.height * 100;
                    }
                    else if(this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_RESIZE_FROM_BOTTOM)
                    {
                        // 下固定
                        dstTrimY = this.srcTrimY + vector.y / this.currentLayer.height * 100;
                        dstTrimHeight = this.srcTrimHeight - vector.y / this.currentLayer.height * 100;
                    }
                    else if(this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_RESIZE_FROM_BOTTOM_RIGHT)
                    {
                        // 右下固定
                        dstTrimX = this.srcTrimX + vector.x / this.currentLayer.width * 100;
                        dstTrimY = this.srcTrimY + vector.y / this.currentLayer.height * 100;
                        dstTrimWidth = this.srcTrimWidth - vector.x / this.currentLayer.width * 100;
                        dstTrimHeight = this.srcTrimHeight - vector.y / this.currentLayer.height * 100;
                    }
                    else if(this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_RESIZE_FROM_RIGHT)
                    {
                        // 右固定
                        dstTrimX = this.srcTrimX + vector.x / this.currentLayer.width * 100;
                        dstTrimWidth = this.srcTrimWidth - vector.x / this.currentLayer.width * 100;
                    }
                    else if(this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_RESIZE_FROM_TOP_RIGHT)
                    {
                        // 右上固定
                        dstTrimX = this.srcTrimX + vector.x / this.currentLayer.width * 100;
                        dstTrimWidth = this.srcTrimWidth - vector.x / this.currentLayer.width * 100;
                        dstTrimHeight = this.srcTrimHeight + vector.y / this.currentLayer.height * 100;
                    }
                    else if(this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_RESIZE_FROM_TOP)
                    {
                        // 上固定
                        dstTrimHeight = this.srcTrimHeight + vector.y / this.currentLayer.height * 100;
                    }

                    // 値補正
                    if(dstTrimWidth < 0)
                    {
                        dstTrimWidth *= -1;
                        dstTrimX -= dstTrimWidth;
                    }
                    if(dstTrimHeight < 0)
                    {
                        dstTrimHeight *= -1;
                        dstTrimY -= dstTrimHeight;
                    }
                    if(dstTrimX < 0)
                    {
                        dstTrimWidth += dstTrimX;
                        dstTrimX = 0;
                    }
                    if(dstTrimX + dstTrimWidth > 100)
                    {
                        dstTrimWidth -= dstTrimX + dstTrimWidth - 100;
                        dstTrimWidth = 100 - dstTrimX;
                    }
                    if(dstTrimY < 0)
                    {
                        dstTrimHeight += dstTrimY;
                        dstTrimY = 0;
                    }
                    if(dstTrimY + dstTrimHeight > 100)
                    {
                        dstTrimHeight -= dstTrimY + dstTrimHeight - 100;
                        dstTrimHeight = 100 - dstTrimY;
                    }
                    
                    // トリミング
                    this.$emit("doCommand", "trimLayer", { layer : this.currentLayer, 
                        x : dstTrimX, y : dstTrimY, width : dstTrimWidth, height : dstTrimHeight, 
                        isFinish : false });
                }
                return;
            }

            if(this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_CONTROL_LINE_START)
            {
                // 直線レイヤーの始点変更
                var newX = this.srcLayerX + deltaXInDesign;
                var newY = this.srcLayerY + deltaYInDesign;
                this.$emit("doCommand", "changeLayerProperty", { layer : this.currentLayer, propertyName : "startX", value : newX, isFinish : false });
                this.$emit("doCommand", "changeLayerProperty", { layer : this.currentLayer, propertyName : "startY", value : newY, isFinish : false });
                return;
            }
            if(this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_CONTROL_LINE_END)
            {
                // 直線レイヤーの終点変更
                var newX = this.srcLayerX + this.srcLayerWidth + deltaXInDesign;
                var newY = this.srcLayerY + this.srcLayerHeight + deltaYInDesign;
                this.$emit("doCommand", "changeLayerProperty", { layer : this.currentLayer, propertyName : "endX", value : newX, isFinish : false });
                this.$emit("doCommand", "changeLayerProperty", { layer : this.currentLayer, propertyName : "endY", value : newY, isFinish : false });
                return;
            }
            if(this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_CONTROL_CURVE)
            {
                // 曲線レイヤーの制御点変更
                if(this.currentLayer instanceof CurveLayer)
                {
                    var newControlPointX = this.srcControlPointX + deltaXInDesign;
                    var newControlPointY = this.srcControlPointY + deltaYInDesign;
                    this.$emit("doCommand", "moveCurveControlPoint", { layer : this.currentLayer, index : this.selectedCurveControlPointIndex, x : newControlPointX, y : newControlPointY, isFinish : false });
                }
                return;
            }
            if(this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_CONTROL_POLYGON)
            {
                // 多角形レイヤーの制御点変更
                if(this.currentLayer instanceof PolygonLayer)
                {
                    // 移動ベクトルを回転する
                    var newControlPointX = this.srcControlPointX + deltaXInDesign;
                    var newControlPointY = this.srcControlPointY + deltaYInDesign;
                    // 新しい多角形の制御点は、(newControlPointX, newControlPointY), これ以外は同じ位置
                    var dstRotated : Array<Vector2> = new Array();
                    for(var i = 0; i < this.currentLayer.getControlPointsNumber(); ++i)
                    {
                        if(i == this.selectedPolygonControlPointIndex)
                        {
                            dstRotated.push(new Vector2(newControlPointX, newControlPointY));
                        }
                        else
                        {
                            dstRotated.push(this.currentLayer.getRotatedControlPoint(i));
                        }
                    }
                    this.$emit("doCommand", "applyPolygonControlPoints", { layer : this.currentLayer, points : dstRotated, isFinish : false, isOnce : false });
                }
                return;
            }

            // レイヤーの回転角を元にベクトルを分解
            var vector = new Vector2(deltaXInDesign, deltaYInDesign).getResolutionDegrees(this.currentLayer.rotate);

            // レイヤーの移動・リサイズ後の情報
            var dstX = this.srcLayerX;
            var dstY = this.srcLayerY;
            var dstWidth = this.srcLayerWidth;
            var dstHeight = this.srcLayerHeight;
            var dstRotate = this.srcLayerRotate;
            
            // 中心位置を保持するか
            var isKeepCenter = false;
            // 左上、左下、右下、右上位置を保持するか
            var isKeepVertex : boolean[] = [false, false, false, false];
            // 縦横比固定か
            var keepRatio = this.currentLayer["keepRatio"] != null && this.currentLayer["keepRatio"] == 0;

            if(this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_RESIZE_FROM_TOP_LEFT)
            {
                // 左上固定 -> 幅・高さ可変
                isKeepVertex[0] = true;
                dstWidth = this.srcLayerWidth + vector.x
                dstHeight = this.srcLayerHeight + vector.y;
            }
            else if(this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_RESIZE_FROM_LEFT)
            {
                // 左固定 -> 幅可変
                isKeepVertex[0] = true;
                isKeepVertex[1] = true;
                dstWidth = this.srcLayerWidth + vector.x;
            }
            else if(this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_RESIZE_FROM_BOTTOM_LEFT)
            {
                // 左下固定 -> 幅・高さ可変
                isKeepVertex[1] = true;
                dstWidth = this.srcLayerWidth + vector.x;
                dstHeight = this.srcLayerHeight - vector.y;
            }
            else if(this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_RESIZE_FROM_BOTTOM)
            {
                // 下固定 -> 高さ可変
                isKeepVertex[1] = true;
                isKeepVertex[2] = true;
                dstHeight = this.srcLayerHeight - vector.y;
            }
            else if(this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_RESIZE_FROM_BOTTOM_RIGHT)
            {
                // 右下固定 -> 幅、高さ可変
                isKeepVertex[2] = true;
                dstWidth = this.srcLayerWidth - vector.x;
                dstHeight = this.srcLayerHeight - vector.y;
            }
            else if(this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_RESIZE_FROM_RIGHT)
            {
                // 右固定 -> 幅可変
                isKeepVertex[2] = true;
                isKeepVertex[3] = true;
                dstWidth = this.srcLayerWidth - vector.x;
            }
            else if(this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_RESIZE_FROM_TOP_RIGHT)
            {
                // 右上固定 -> 幅、高さ可変
                isKeepVertex[3] = true;
                dstWidth = this.srcLayerWidth - vector.x;
                dstHeight = this.srcLayerHeight + vector.y;
            }
            else if(this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_RESIZE_FROM_TOP)
            {
                // 上固定 -> 高さ可変
                isKeepVertex[3] = true;
                isKeepVertex[0] = true;
                dstHeight = this.srcLayerHeight + vector.y;
            }
            else if(this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_ROTATE)
            {
                // 回転
                // 現在のマウス座標をdesign座標系に変換
                var xInDesign = this.toDesignPointFromClient(event.clientX, event.clientY).x;
                var yInDesign = this.toDesignPointFromClient(event.clientX, event.clientY).y;
                // レイヤーの中心座標との差
                var fromCenterX = xInDesign - this.currentLayer.centerX;
                var fromCenterY = yInDesign - this.currentLayer.centerY;
                // アークタンジェントを取る
                var atan = this.currentLayer.height >= 0 ? Math.atan2(fromCenterX, -fromCenterY) : Math.atan2(-fromCenterX, fromCenterY);
                // degreesに変換したものを回転角とする。
                dstRotate = atan * 180 / Math.PI;
                // 角度を -180 ~ 180 に収める
                while ( dstRotate < -180 ) { dstRotate += 360; }
                while ( dstRotate > 180 ) { dstRotate -= 360; }
                // x, yの値は回転後に中心がずれない位置に変更する。
                isKeepCenter = true;
            }
            else if(this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_MOVE)
            {
                // 移動
                dstX = this.srcLayerX + deltaXInDesign;
                dstY = this.srcLayerY + deltaYInDesign;
            }

            // 縦横比固定処理
            var applyKeepRatio = 
                (isKeepVertex[0] && !isKeepVertex[1] && !isKeepVertex[2] && !isKeepVertex[3]) ||
                (!isKeepVertex[0] && isKeepVertex[1] && !isKeepVertex[2] && !isKeepVertex[3]) ||
                (!isKeepVertex[0] && !isKeepVertex[1] && isKeepVertex[2] && !isKeepVertex[3]) ||
                (!isKeepVertex[0] && !isKeepVertex[1] && !isKeepVertex[2] && isKeepVertex[3]);
            if(keepRatio && applyKeepRatio)
            {
                var deltaWidth = dstWidth - this.currentLayer.width;
                var deltaHeight = dstHeight - this.currentLayer.height;
                if(deltaWidth * deltaWidth > deltaHeight * deltaHeight)
                {
                    dstWidth = dstHeight * this.srcLayerWidth / this.srcLayerHeight;
                }
                else
                {
                    dstHeight = dstWidth * this.srcLayerHeight / this.srcLayerWidth;
                }
            }

            // 回転前の中心座標を保持
            var srcCenterX = this.currentLayer.centerX;
            var srcCenterY = this.currentLayer.centerY;
            // 拡大縮小前の頂点座標を保持
            var vertexes = this.currentLayer.getVertexes();

            // 現在の値を保持
            var currentX = this.currentLayer.x;
            var currentY = this.currentLayer.y;
            var currentWidth = this.currentLayer.width;
            var currentHeihgt = this.currentLayer.height;
            var currentRotate = this.currentLayer.rotate;

            // レイヤーに一時的に適用
            this.currentLayer.width = dstWidth;
            this.currentLayer.height = dstHeight;
            this.currentLayer.rotate = dstRotate;
            this.currentLayer.x = dstX;
            this.currentLayer.y = dstY;

            // 回転後の頂点を取得する
            var dstVertexes = this.currentLayer.getVertexes();

            for(var i = 0; i < vertexes.length; ++i)
            {
                if(isKeepVertex[i])
                {
                    // 頂点座標が一致するように移動
                    this.currentLayer.x += -dstVertexes[i].x + vertexes[i].x;
                    this.currentLayer.y += -dstVertexes[i].y + vertexes[i].y;
                    break;
                }
            }

            if(isKeepCenter)
            {
                // 回転後の中心座標を取得する
                var dstCenterX = this.currentLayer.centerX;
                var dstCenterY = this.currentLayer.centerY;
                // 中心座標が回転前の値に戻るように移動
                this.currentLayer.x += -dstCenterX + srcCenterX;
                this.currentLayer.y += -dstCenterY + srcCenterY;
            }

            // この段階ので値を保持
            var newX = this.currentLayer.x;
            var newY = this.currentLayer.y;
            var newWidth = this.currentLayer.width;
            var newHeight = this.currentLayer.height;
            var newRotate = this.currentLayer.rotate;

            // 元に戻す
            this.currentLayer.width = currentWidth;
            this.currentLayer.height = currentHeihgt;
            this.currentLayer.rotate = currentRotate;
            this.currentLayer.x = currentX;
            this.currentLayer.y = currentY;
            
            // 変形コマンド発行を継続で送る
            this.$emit("doCommand", "transformLayer", { layer : this.currentLayer, 
                x : newX, y : newY, width : newWidth, height : newHeight, 
                rotate : newRotate, isFinish : false });
        }
        else if(this.currentLayer instanceof TextLayer && this.isTextSelecting)
        {
            // テキスト選択中であれば選択ポジションの変化をチェック
            var srcTextPosition = this.currentLayer.getPositionFromLineAndCharacterIndex(this.srcTextSelectedLineIndex, this.srcTextSelectedCharacterIndex, this.srcTextIsAfterSelected);
            var dstTextPosition = this.currentLayer.getPositionFromLineAndCharacterIndex(this.currentLayer.selectedLineIndex, this.currentLayer.selectedCharacterIndex, this.currentLayer.isAfterSelected);
            // この位置を範囲選択する
            var editor = this.$refs.inlineTextEditor as InlineTextEditor;
            editor.select(Math.min(srcTextPosition, dstTextPosition), Math.max(srcTextPosition, dstTextPosition));
        }
    }

    private onMouseUp(event : MouseEvent)
    {
        if(this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_SELECT_AREA)
        {
            // 選択レイヤー状態取得
            var startX = this.toDesignPointFromClient(this.mouseStartX, this.mouseStartY).x;
            var startY = this.toDesignPointFromClient(this.mouseStartX, this.mouseStartY).y;
            var endX = this.toDesignPointFromClient(this.mouseCurrentX, this.mouseCurrentY).x;
            var endY = this.toDesignPointFromClient(this.mouseCurrentX, this.mouseCurrentY).y;
            var x = Math.min(startX, endX);
            var y = Math.min(startY, endY);
            var width = Math.abs(startX - endX);
            var height = Math.abs(startY - endY);
            var selectedLayers = this.design.getLayersRectContained(x, y, width, height);
            for(var i = selectedLayers.length - 1; i >= 0; --i)
            {
                this.design.addSelectLayer(selectedLayers[i]);
            }
        }
        else if(this.mouseMovingMode == CanvasWindow.MOUSE_MOVING_MODE_MOVE_MULTI)
        {
            // 複数レイヤー移動を確定
            this.fixMultiCommand();
            // 情報のクリア
            this.srcMultiLayersPositionMap = {};
        }
        else if(this.mouseMovingMode != CanvasWindow.MOUSE_MOVING_MODE_NONE && this.currentLayer != null)
        {
            // コマンド確定を送る
            this.fixMultiCommand();
        }

        // マウス移動時の動作変更
        this.mouseMovingMode = CanvasWindow.MOUSE_MOVING_MODE_NONE;
        // テキスト選択中フラグオフ
        this.isTextSelecting = false;
    }

    private onContextMenu(event: MouseEvent)
    {
        // 右クリックのイベント

        // マウス座標をデザイン座標系に変換
        var xInDesign = this.toDesignPointFromClient(event.clientX, event.clientY).x;
        var yInDesign = this.toDesignPointFromClient(event.clientX, event.clientY).y;

        // マウス位置にあるレイヤーを調べ、最前面にあるレイヤーを返す
        var isTargetLayer = false;
        var foundLayers = this.design.getLayersFromPosition(xInDesign, yInDesign);
        var targetLayer : Layer | null = foundLayers.length > 0 ? foundLayers[foundLayers.length - 1] : null;
        if(targetLayer != null)
        {
            isTargetLayer = true;
            // デフォルトの右クリックのウィンドゥを表示しない
            event.preventDefault();
            this.onDoCommand("showContextMenu", { event: event, type: "layer" });
        }
    }

    // テキストが編集中か
    public get isTextInEdit() : boolean
    {
        if (this.currentLayer == null) { return false; }
        if (this.currentLayer instanceof TextLayer)
        {
            var textLayer = this.currentLayer as TextLayer;
            return textLayer.inEdit;
        }
        return false;
    }

    // テキスト編集中フラグ切り替え
    public set isTextInEdit(isTextInEdit : boolean)
    {
        var editor = this.$refs.inlineTextEditor as InlineTextEditor;

        DebugHelper.trace(isTextInEdit)
        // mobileではtrueにさせない
        if(isTextInEdit) { return; }
        if(isTextInEdit)
        {
            if (this.currentLayer == null) { return; }

            var text = "";
            if (this.currentLayer instanceof TextLayer)
            {
                var textLayer = this.currentLayer as TextLayer;

                // 選択ポジション取得
                var pos = textLayer.getPositionFromLineAndCharacterIndex(textLayer.selectedLineIndex, textLayer.selectedCharacterIndex, textLayer.isAfterSelected);

                textLayer.inEdit = true;

                // 文字設定
                text = textLayer.text;
                if(editor != null)
                {
                    editor.setText(text);
                    editor.focus(false, pos, pos);
                }
            }
        }
        else
        {
            // すべてのテキストレイヤーから編集フラグを落とす
            var allLayers = this.design.getAllLayers();
            for(var i = 0; i < allLayers.length; ++i)
            {
                if(allLayers[i] instanceof TextLayer)
                {
                    var textLayer = allLayers[i] as TextLayer;
                    textLayer.inEdit = false;
                }
            }

            if(editor != null)
            {
                editor.setText("");
                editor.unfocus();
            }
        }
    }

    private get isVerticalInEdit()
    {
        // テキストが縦書きかどうか
        var result = false;
        if(this.currentLayer != null)
        {
            if(this.currentLayer instanceof PlainTextLayer)
            {
                result = this.currentLayer.textOrientation == 1;
            }
        }
        return result;
    }

    // テキストの編集が行われた
    private onChangeText(text : string)
    {
        if(this.currentLayer == null) { return; }

        if(this.currentLayer instanceof TextLayer)
        {
            this.$emit("doCommand", "changeText", { layer : this.currentLayer, text : text, isFinish : false });
        }
    }

    // テキスト編集が行われた
    private onChangeTextEditor(parameter)
    {
        if(this.currentLayer == null) { return; }

        var text = parameter.text;
        if(this.currentLayer instanceof TextLayer)
        {
            this.$emit("doCommand", "changeText", { layer : this.currentLayer, text : text, isFinish : false });
        }
    }

    // テキスト確定された
    private onFixTextEditor()
    {
        this.fixMultiCommand();
    }

    private onChangeSelectionEditor(parameter)
    {
        if(this.currentLayer == null) { return; }

        if(this.currentLayer instanceof TextLayer)
        {
            this.currentLayer.lastStartPosition = this.currentLayer.startPosition;
            this.currentLayer.lastEndPosition = this.currentLayer.endPosition;
            this.currentLayer.startPosition = parameter.start;
            this.currentLayer.endPosition = parameter.end;
        }
    }

    // マルチコマンドを確定する
    private fixMultiCommand()
    {
        this.$emit("doCommand", "fixMultiCommand", null);
    }

    // 画面上のクライアント座標 -> design座標
    private toDesignPointFromClient(x, y)
    {
        // クライアント座標 -> SVG座標
        var svgPoint = this.toSVGPointFromClient(x, y);
        // SVG座標 -> design座標
        return new Vector2((svgPoint.x - this.canvasX) / this.scale, (svgPoint.y - this.canvasY) / this.scale);
    }

    // クライアント座標　-> SVG座標
    private toSVGPointFromClient(x, y)
    {
        var svg = this.getSvgElement();
        if(svg == null) { return new Vector2(0, 0); }
        var point = svg.createSVGPoint();
        point.x = x;
        point.y = y;

        var m = svg.getScreenCTM();
        if(m == null) { return new Vector2(0, 0); }
        var p = point.matrixTransform(m.inverse());
        return new Vector2(p.x, p.y);
    }

    // 自動リサイズする
    public autoResize()
    {
        // サイズの調整
        var zoomScale = 100;
        if(UserAgentHelper.isMobile())
        {
            var designWidthPx = UnitHelper.convert(this.design.width, "mm", "pt");
            var designHeightPx = UnitHelper.convert(this.design.height, "mm", "pt");
            var wScale = (window.innerWidth - 16 * 2) / designWidthPx;
            var hScale = (window.innerHeight - 16 * 2) / designHeightPx;
            zoomScale = Math.min(wScale, hScale) * 100;
        }
        else
        {
            var wScale = (Math.max(window.innerWidth, CanvasWindow.FIXED_PX_BASE_WIDTH) - 280) / this.getCanvasWindowBaseWidth();
            var hScale = (Math.max(window.innerHeight, CanvasWindow.FIXED_PX_BASE_HEIGHT) -170) / this.getCanvasWindowBaseHeight();
            zoomScale = Math.min(wScale, hScale) * 100 * 2.5;   // 2.5は目視による大きさ変更
        }

        // 整数化
        zoomScale = Math.floor(zoomScale);
        if(zoomScale < Const.CANVAS_ZOOM_MIN) { zoomScale = Const.CANVAS_ZOOM_MIN; }
        if(zoomScale > Const.CANVAS_ZOOM_MAX) { zoomScale = Const.CANVAS_ZOOM_MAX; }
        this.onDoCommand("changeZoomScale", { scale : zoomScale });
    }

    // zoomを元にしてフレームのstyleを調整
    private adjustFrameSize()
    {
        this.svgWrapperStyle = {
            width: this.getCanvasWindowBaseWidth() * this.zoomScale / 100 + "px",
            height: this.getCanvasWindowBaseHeight() * this.zoomScale / 100 + "px",
            left: "0",   top: "0",   transform: "translate(0, 0)"
        };
    }

    // 拡大率100%のときのCanvasWindowの幅
    private getCanvasWindowBaseWidth()
    {
        // デザイン幅
        var designWidth = this.design.width;
        // mm -> pt
        var designWidthPt = UnitHelper.convert(designWidth, "mm", "pt");
        // この値がpxと一致するような幅
        var width = designWidthPt * CanvasWindow.CANVAS_OFFSET_FACTOR;
        return width;
    }

    // 拡大率100%のときのCanvasWindowの高さ
    private getCanvasWindowBaseHeight()
    {
        // デザイン高さ
        var designHeight = this.design.height;
        // mm -> pt
        var designHeightPt = UnitHelper.convert(designHeight, "mm", "pt");
        // この値がpxと一致するような幅
        var height = designHeightPt * CanvasWindow.CANVAS_OFFSET_FACTOR;
        return height;
    }

    // svg全体の表示位置調整
    private adjustFramePosition()
    {
        var canvasWindow = this.$refs.canvasWindow as Element;
        var svg = this.$refs.svg as HTMLElement;
        var canvasWidth = canvasWindow.clientWidth;
        if(canvasWidth == 0) { canvasWidth = canvasWindow.getBoundingClientRect().width; }
        var canvasHeight = canvasWindow.clientHeight;
        if(canvasHeight == 0) { canvasHeight = canvasWindow.getBoundingClientRect().height; }
        var svgWidth = svg.clientWidth;
        if(svgWidth == 0) { svgWidth = svg.getBoundingClientRect().width; }
        var svgHeight = svg.clientHeight;
        if(svgHeight == 0) { svgHeight = svg.getBoundingClientRect().height; }

        var width = this.getCanvasWindowBaseWidth() * this.zoomScale / 100;
        var height = this.getCanvasWindowBaseHeight() * this.zoomScale / 100;
        var left = "0";
        var top = "0";
        if(canvasWidth > svgWidth)
        {
            left = "calc(50% - " + (width / 2) + "px)";
        }
        if(canvasHeight > svgHeight)
        {
            top = "calc(50% - " + (height / 2) + "px)";
        }
        this.svgWrapperStyle = {
            width: width + "px",
            height: height + "px",
            left: left,
            top: top,
            transform: "translate(0, 0)"
        };
    }

    // zoom時のスクロール位置調整
    private zoomPositioning(val: number, oldVal: number){
        var canvasWindow = this.$refs.canvasWindow as Element;
        var svg = this.$refs.svg;

            
        if(!isElement(canvasWindow)) return;
        if(!isElement(svg)) return;

        if(this.isFirst){
            canvasWindow.scrollLeft = (svg.clientWidth - canvasWindow.clientWidth) / 2;
            canvasWindow.scrollTop = (svg.clientHeight - canvasWindow.clientHeight) / 2;
            this.scrollBeforeScale = val;

            this.oldScroll.left = canvasWindow.scrollLeft;
            this.oldScroll.top = canvasWindow.scrollTop;

            this.isFirst = false;
        }else if(val != oldVal){
            if(this.svgWrapperStyle.left == "0"){
                // 横スクロールが可能な時
                canvasWindow.scrollLeft = (this.oldScroll.left + canvasWindow.clientWidth / 2) / oldVal * val - canvasWindow.clientWidth / 2;
                this.oldScroll.left = canvasWindow.scrollLeft;
            }else{
                // 横スクロールが不可能な時
                this.oldScroll.left = (svg.clientWidth - canvasWindow.clientWidth) / 2;
            }
            if(this.svgWrapperStyle.top == "0"){
                // 縦スクロールが可能な時
                canvasWindow.scrollTop = (this.oldScroll.top + canvasWindow.clientHeight / 2) / oldVal * val - canvasWindow.clientHeight / 2;;
                this.oldScroll.top = canvasWindow.scrollTop;
            }else{
                // 縦スクロールが不可能な時
                this.oldScroll.top = (svg.clientHeight - canvasWindow.clientHeight) / 2;
            }
        }
    }
    // autoMode時のzoom位置調整
    private autoZoomPositioning(){
        var canvasWindow = this.$refs.canvasWindow as Element;
        var svg = this.$refs.svg;

        if(!isElement(canvasWindow)) return;
        if(!isElement(svg)) return;

        canvasWindow.scrollLeft = (this.svgClientWidth(svg) - canvasWindow.clientWidth) / 2;
        canvasWindow.scrollTop = (this.svgClientHeight(svg) - canvasWindow.clientHeight) / 2;
    }

    private svgClientWidth(svg: Element): number {
        return svg.clientWidth || svg.getBoundingClientRect().width
    }

    private svgClientHeight(svg: Element): number {
        return svg.clientHeight || svg.getBoundingClientRect().height
    }

    // 強制的にテキストの編集を開始する
    public forceStartEditText()
    {
        this.isTextInEdit = true;
    }

    // Utility
    // テキストサイズを測る
    public calcTextSize(str : string, fontSize : number, isBold : boolean = false, isItalic : boolean = false, isVertical : boolean = false)
    {
        var fontId = FontManager.DEFAULT_FONT_ID;
        var isHankaku = StringHelper.isHankaku(str);

        // fontSize -> pt
        var fontSizePt = UnitHelper.convert(fontSize / this.scale, "mm", "pt");
        var fontManager : FontManager = this.$store.getters.fontManager;
        var font = fontManager.getFontFamilyById(fontId);

        // fontFamily
        var fontFamily = fontManager.getFontFamilyName(fontId, isHankaku, false, isVertical);

        // weight
        var weight = "normal";
        if(font.weight == null)
        {
            // ウェイトがない場合はボールド設定を返す
            weight = isBold ? "bold" : "normal";
        }
        else
        {
            // ウェイトがある場合
            if(isBold)
            {
                weight = font.weight > 700 ? font.weight.toString() : "bold";
            }
            else
            {
                weight = font.weight.toString();
            }
        }

        // style
        var style = isItalic && fontManager.canItalic(fontId, isHankaku) ? "italic" : "normal";

        var ptSize = StringHelper.calcTextSizeOnSVGPt(str, fontSizePt, fontFamily, weight, style, isVertical);

        var width = UnitHelper.convert(ptSize.width, "pt", "mm") * this.scale;
        var height = UnitHelper.convert(ptSize.height, "pt", "mm") * this.scale;

        return { width : width, height : height };
    }

    overFlowVisible = false
    svgWrapperStyleBefore = {width: "", height: "", left: "",   top: "",   transform: ""};
    canvasWindowScrollLeftBefore = 0
    canvasWindowScrollTopBefore = 0

    fixCanvasArea(){
        var canvasWindow = this.$refs.canvasWindow as HTMLElement
        this.svgWrapperStyleBefore.left = this.svgWrapperStyle.left
        this.svgWrapperStyleBefore.top = this.svgWrapperStyle.top
        this.svgWrapperStyle.left = "-" + canvasWindow.scrollLeft
        this.svgWrapperStyle.top = "-" + canvasWindow.scrollTop
        this.canvasWindowScrollLeftBefore = canvasWindow.scrollLeft
        this.canvasWindowScrollTopBefore = canvasWindow.scrollTop

        this.overFlowVisible = true
    }

    unfixCanvasArea(){

        this.svgWrapperStyle.left = this.svgWrapperStyleBefore.left
        this.svgWrapperStyle.top = this.svgWrapperStyleBefore.top
        this.overFlowVisible = false

        this.$nextTick(()=>{
            var canvasWindow = this.$refs.canvasWindow as HTMLElement
            canvasWindow.scrollLeft = this.canvasWindowScrollLeftBefore
            canvasWindow.scrollTop = this.canvasWindowScrollTopBefore
        })
        
    }

    //----------上部の、用紙情報の部分----------//
    get selectedPaper(){
        return this.$store.getters.data.selectedPaper
    }
    //----------上部の、用紙情報の部分----------//

}
